var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pan-item",style:({zIndex:_vm.zIndex,height:_vm.height,width:_vm.width})},[_c('div',{staticClass:"pan-info"},[_c('div',{staticClass:"pan-info-roles-container"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"pan-thumb",style:({backgroundImage: ("url(" + _vm.image + ")")})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72e02616","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PanThumb/index.vue
// module id = null
// module chunks = 